import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, ButtonGroup } from '@lib/components/v2/Form';
import classes from './Modal.style.module.scss';

/**
 * A sample Modal
 */
const Modal = ({ children, isOpen, small, heading, buttons, success, className }) => {
  return (
    <div
      className={classNames(classes.wrapper, isOpen && classes.open, className)}
      aria-modal="true"
    >
      <div
        className={classNames(classes.modalContent, isOpen && classes.open, small && classes.small)}
      >
        <div className={classNames(classes.dialog)}>
          <div className="text-center">
            {!success && <img alt="" width="64" src="images/icons/png/issue-videoid.png" />}
            {success && <img alt="" width="64" src="images/icons/svg/icon_completed.svg" />}
          </div>
          {heading && <div className={classes.heading}>{heading}</div>}
          {children}
          {buttons.length > 0 && (
            <div className={classes.footer}>
              <ButtonGroup btnCount={buttons.length}>
                {buttons.map((button) => (
                  <Button key={button.label} {...button} />
                ))}
              </ButtonGroup>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  small: PropTypes.bool,
  success: PropTypes.bool,
  heading: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      shadow: PropTypes.bool,
      large: PropTypes.bool
    })
  )
};

Modal.defaultProps = {
  isOpen: false,
  success: false
};

export default Modal;
